import type { Point } from '@ikegps/core-api';
import { m } from '../mithril';
import { ClassNames, StyleConfig } from '../theme';
export interface DrawPointCtx {
	draggable: boolean;
	label?: IkeDrawLabel;
	className: string;
	scale: number;
	radius: number;
	stroke?: string;
	fill?: string;
	nodeId?: string;
}

export const IkeDrawLabel = {
	POINT: 'point' as const,
	START: 'start' as const,
	END: 'end' as const,
	LABEL: 'label' as const,
	IMAGE: 'image' as const,
	DELETE: 'delete' as const,
	ACCEPT: 'accept' as const,
};

export type IkeDrawLabel =
	| typeof IkeDrawLabel.POINT
	| typeof IkeDrawLabel.START
	| typeof IkeDrawLabel.END
	| typeof IkeDrawLabel.IMAGE
	| typeof IkeDrawLabel.DELETE
	| typeof IkeDrawLabel.LABEL
	| typeof IkeDrawLabel.ACCEPT;

export class SVGUtil {
	static DrawLine(pointA: Point, pointB: Point, strokeWidth: number, stroke: string, className?: string) {
		const extraClassName = className ? ' ' + className : '';
		return m('line', {
			className: ClassNames.line.container + extraClassName,
			stroke,
			'stroke-width': strokeWidth,
			x1: pointA.x,
			x2: pointB.x,
			y1: pointA.y,
			y2: pointB.y,
		});
	}

	static DrawMoveLine(
		pointA: Point,
		pointB: Point,
		uiScale: number,
		label: IkeDrawLabel = IkeDrawLabel.POINT,
		className?: string
	) {
		var extraClassName = className ? ' ' + className : '';
		var strokeWidth = uiScale * StyleConfig.STROKE_WIDTH * 10;
		var node = SVGUtil.DrawLine(
			pointA,
			pointB,
			strokeWidth,
			'transparent',
			ClassNames.line.move + ' ' + ClassNames.isMoveable + ' ' + extraClassName
		);
		node.attrs['c-Draw-draggable'] = 'true';
		node.attrs['c-Draw-Label'] = label;
		return node;
	}

	static DrawLineMain(pointA: Point, pointB: Point, uiScale: number, className?: string) {
		var extraClassName = className ? ' ' + className : '';
		var strokeWidth = uiScale * StyleConfig.STROKE_WIDTH;
		return SVGUtil.DrawLine(pointA, pointB, strokeWidth * 2, StyleConfig.STROKE, ClassNames.line.main + extraClassName);
	}

	static DrawLineSecondary(pointA: Point, pointB: Point, uiScale: number, fillColor: string, className?: string) {
		var extraClassName = className ? ' ' + className : '';
		var strokeWidth = uiScale * StyleConfig.STROKE_WIDTH;
		return SVGUtil.DrawLine(pointA, pointB, strokeWidth, fillColor, ClassNames.line.secondary + extraClassName);
	}

	static DrawLineBordered(pointA: Point, pointB: Point, uiScale: number, fillColor: string, className?: string) {
		const borderLine = this.DrawLineMain(pointA, pointB, uiScale, className);
		const innerLine = this.DrawLineSecondary(pointA, pointB, uiScale, fillColor, className);
		return [borderLine, innerLine];
	}

	static DrawPoint(point: Point, ctx: DrawPointCtx) {
		var extraClassName = ctx.className ? ' ' + ctx.className : '';

		const attrs = {
			className: ClassNames.point.container + extraClassName,
			cx: point.x,
			cy: point.y,
			r: ctx.radius || 0,
			fill: ctx.fill ? ctx.fill : StyleConfig.LABEL.FILL,
			stroke: ctx.stroke ? ctx.stroke : StyleConfig.LABEL.STROKE,
			'stroke-width': ctx.scale * StyleConfig.STROKE_WIDTH,
			'c-Draw-draggable': ctx.draggable ? 'true' : null,
			'c-Draw-Label': ctx.label ?? IkeDrawLabel.LABEL,
		};

		if (ctx.nodeId) {
			attrs['c-Draw-node-id'] = ctx.nodeId;
		}

		return m('circle', attrs);
	}
}
